import { Grid } from '@csp/csp-web-ui';
import { FC } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { SuspenseLoader } from '../../../common/component/SuspenseLoader';
import { MainContent } from '../../../common/component/layout/MainContent';
import { HeaderNavBar } from '../component/HeaderNavBar';
import { InformedConsentNavSubTabsContainer } from '../container/InformedConsentNavSubTabsContainer';
import { MainNavTabsContainer } from '../container/MainNavTabsContainer';
import { PatientNavSubTabsContainer } from '../container/PatientNavSubTabsContainer';
import { ReportsNavSubTabsContainer } from '../container/ReportsNavSubTabsContainer';
import { StudyOverviewNavSubTabsContainer } from '../container/StudyOverviewNavSubTabsContainer';
import { useMainNavPages } from '../hooks/useMainNavPages';

export const MainNavPages: FC = () => {
  const { goBack, hasMultipleStudies, study, texts } = useMainNavPages();

  const shouldRenderInformedConsentTab = !!useMatch(`${CspPath.INFORMED_CONSENT}/*`);
  const shouldRenderReportsTab = !!useMatch(`${CspPath.REPORTS}/*`);
  const shouldRenderStudyOverviewTab = !!useMatch(`${CspPath.STUDY_OVERVIEW}/*`);
  const shouldRenderPatientTab = !!useMatch(`${CspPath.PATIENT_LIST}/*`);
  const matchStudyOverview = useMatch(`${CspPath.STUDY_OVERVIEW_DOCUMENTS}/*`);
  const matchPatientListVisit = useMatch(`${CspPath.PATIENT_LIST_VISIT}/*`);
  const matchPatientList = useMatch(`${CspPath.PATIENT_LIST_STANDARD}/*`);
  const matchPatientListCloseout = useMatch(`${CspPath.PATIENT_LIST_CLOSEOUT}/*`);

  // TODO: [Saman M]: remove isOnFullWidthRoute after migration sticky header in the list
  const isOnFullWidthRoute =
    !!matchStudyOverview || !!matchPatientListVisit || !!matchPatientList || !!matchPatientListCloseout;
  return (
    <Grid container>
      <HeaderNavBar
        onBackButtonClick={goBack}
        replaceLogoWithBackButton={hasMultipleStudies}
        title={study.name ?? ''}
        subtitle={study.dcode ?? texts.topBar.button.myStudies.label}
      >
        <MainNavTabsContainer tabs={texts.tabs} />

        {shouldRenderPatientTab && <PatientNavSubTabsContainer />}
        {shouldRenderReportsTab && <ReportsNavSubTabsContainer />}
        {shouldRenderInformedConsentTab && <InformedConsentNavSubTabsContainer />}
        {shouldRenderStudyOverviewTab && <StudyOverviewNavSubTabsContainer />}
      </HeaderNavBar>

      {!isOnFullWidthRoute ? (
        <MainContent>
          <SuspenseLoader>
            <Outlet />
          </SuspenseLoader>
        </MainContent>
      ) : (
        <SuspenseLoader>
          <Outlet />
        </SuspenseLoader>
      )}
    </Grid>
  );
};
